<template>
    <div
        class="list-client__container"
    >
        <table-settings
                :labels="labels"
                :rows="Object.keys(managers).length !== 0 ? managers : []"
                :isPreloader="isPreloader()"
                :columnSettings="columnSettings"
                :isActionButtons="false"
                @changeDropdown="onChangeUserLinks"
        >
        </table-settings>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import serviceApi from "../../services/serviceApi";
import schemeApi from '../../schemes/schemeApi';
import TableSettings from "../../components/Tables/TableSettings";
import schemeSettingsGroupHead from '../../schemes/schemeSettingsGroupHead';
let {
  routeShareList,
  routeShareUpdate,
} = schemeApi;
let {columnSettings, labels} = schemeSettingsGroupHead;
export default {
    name: 'ViewSettingsGroupHead',
    components: {
        TableSettings
    },
    /**
     * Данные компонента
     * @property {array} managerList - список менеджеров
     * @property {boolean} isEmptyUsers проверка ответа на пустоту списка пользователей
     * @property {boolean} isGettingList флаг получения списка клиентов
     * @property {boolean} isGettingUserList флаг получения списка пользователей
     */
    data: () => ({
      managerList: [],
        isGettingList: false,

        links: [],
        managers: [],
        columnSettings: columnSettings,
        labels: labels,
        yOffset: null
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {string} activeProjectId - id активного проекта
         */
        ...mapState({
            activeProjectId: state => state.activeProjectId
        }),
    },
    mounted() {
        // устанавливаем текущее название страницы
        this.setCurrentViewName("Группхеды");
        this.getData();
    },
    methods: {
        /**
         * проксируем мутации из стора
         * @property {Function} setCurrentViewName - установить текущее имя страницы
         */
        ...mapMutations([
            'setCurrentViewName'
        ]),
        /**
         * запрос на списка менеджеров
         * @async
         */
        async getData() {
            this.isGettingList = true;
            try {
                let {data = {}} = await serviceApi.post(routeShareList);
                let tableManagers = [];
                let {last_uploaded: lastUploadedItems = {}} = data;
                for (let [key, value] of Object.entries(data.managers)) {
                  tableManagers.push({id: key, name: value, lastUploaded: lastUploadedItems[key] || ""})
                }
                this.managers = tableManagers;
                this.columnSettings.id.selected = data.links;
                this.columnSettings.id.values = data.managers;
                if(this.yOffset !== null){
                  setTimeout(() => {
                    console.log('скролл');
                    window.scroll(0,this.yOffset)
                  }, 300)
                }
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
                else if (error.response.data.data.message === 'Доступ запрещен') {
                    alert('Доступ запрещен');
                    this.$router.push({name: 'analyticsSummary'});
                }
            }
            this.isGettingList = false;
        },
        isPreloader(){
            return this.isGettingList;
        },
        /**
         * запрос на добавление менеджеров к клиенту
         * @async
         * @property {object} data - клиент и выбранные user_ids
         */
        async onChangeUserLinks(data){
          this.yOffset = window.pageYOffset;
          this.isGettingList = true;
            let postData = {
              recipient_id: data.row[data.attribute],
              sharier_ids: data.selected,
            }
            try {
                let {data = []} = await serviceApi.post(routeShareUpdate, postData);
                if(data.message){
                    // alert(data.message);
                }
                this.getData()
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .list-client__container {
        margin-top: 10px;
        padding: 20px 25px;
        background: #fff;
        border-radius: 14px;
        -webkit-box-flex: 1;
    }
    .list-client__item{
        border-radius: 10px;
        border: none;
        background: none;
        color: #2686e6;
        outline: none;
        padding: 10px;
    }
    .list-client__item_pointer{
        cursor: pointer;
    }
    .list-client__item_active{
        background: #dcdcdc;
    }
</style>